
export default {
  name: 'FallbackEventCardType',
  values: {
    view: undefined,
    title: undefined,
    content: undefined,
    onClick: undefined,
  },
  meta: {
    extendable: false,
  },
}
